import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";
import Avatar from "../../elements/Avatar";
import Group from "../../elements/Group";
import { ImageSizes } from "../../elements/Image/ImageTypes";

var Attribution = function Attribution(_ref) {
  var href = _ref.href,
      imgSrc = _ref.imgSrc,
      imgSrcSet = _ref.imgSrcSet,
      name = _ref.name,
      socialButtons = _ref.socialButtons,
      caption = _ref.caption;
  var getClassName = getClassNameFactory(Attribution.displayName);
  var linkProps = {};
  var ElementType = "span";

  if (href) {
    linkProps.href = href;
    ElementType = "a";
  }

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        noImage: !imgSrc
      })
    })
  }, imgSrc && /*#__PURE__*/React.createElement(ElementType, _extends({
    className: getClassName({
      descendantName: "image"
    })
  }, linkProps), /*#__PURE__*/React.createElement(Avatar, {
    alt: name,
    sizes: ImageSizes.AVATAR,
    src: imgSrc,
    srcSet: imgSrcSet
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "body"
    })
  }, /*#__PURE__*/React.createElement(ElementType, _extends({
    className: getClassName({
      descendantName: "name"
    })
  }, linkProps), name), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "caption"
    })
  }, caption), socialButtons && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "social"
    })
  }, /*#__PURE__*/React.createElement(Group, {
    compact: true
  }, socialButtons.map(function (a, i) {
    return /*#__PURE__*/React.createElement(Group.Item, {
      key: i
    }, a);
  })))));
};

Attribution.displayName = "Attribution";
export default Attribution;